import { createContext } from 'react';

import chinaRailway, { ChinaRailway } from './chinaRailway';

export interface StoreContextValue {
  chinaRailway: ChinaRailway;
}

const storeContext = createContext<StoreContextValue>({
  chinaRailway
});

export default storeContext;
